import React, {Fragment} from 'react';
import {  Container } from 'reactstrap';
import ImagesDisplay from './components/ImagesDisplay';
import TestDicom from './components/TestDicom';
import VtkImagesDisplay from './components/VtkImagesDisplay';


const DicomViewerV2 = (props) => {
    
  return (
    <Fragment>
        {/* <ImagesDisplay data={props.location.state.dataImg} pageIndex={props.location.state.pageIndex} /> */}
        {/* <TestDicom data={props.location.state.dataImg} pageIndex={props.location.state.pageIndex} /> */}
        <VtkImagesDisplay data={props.location.state.dataImg} pageIndex={props.location.state.pageIndex}/>
    </Fragment>
  )
}

export default DicomViewerV2